import React from "react";

import { ROUTE_SIM_REPORT_ACTIVITY } from "../../../../routes";

import convertDateToString from "../../../../libs/convertDateToString";

import { StudentReportRows, ReportDetailContainer } from "./styledUserReport";

const StudentReportComponent = ({ reports, loading }) => {
  return (
    <>
      {reports.map((report) => {
        const simID = report?.sim_report ? report.sim_report.sim : null;
        const studentID = report.created_by.id;
        return (
          <StudentReportRows
            to={{
              pathname: `${ROUTE_SIM_REPORT_ACTIVITY}sim_id=${simID}&student_id=${studentID}`,
              state: { report, loading },
            }}
            className="p-relative row mb-3"
            key={report.id}
            $studentsReport
            $seenReport={report.is_read}
          >
            <ReportDetailContainer className="col-12 col-lg-3 p-0" $studentsReport>
              <img
                src={report.created_by.image}
                alt="student-profile"
                className="mx-2"
              />
              <p className="p-0 mb-0 flex-frow-1">{report.created_by.name}</p>
            </ReportDetailContainer>

            <p className="student-report-sim col-12 col-lg-7 mb-3 mb-md-0">
              گزارش فعالیت آزمایش&nbsp;
              {report?.sim_report && report?.sim_report.sim_name}
            </p>

            <span
              dir="ltr"
              className="col-12 col-lg-2 flex-grow-1 text-start px-lg-4"
            >
              {convertDateToString("fullNumber", report?.created_at)}
            </span>
          </StudentReportRows>
        );
      })}
    </>
  );
};

export default StudentReportComponent;
